var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "popover-container",
      on: {
        click: _vm.onClickPopover,
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _vm.$slots["btnSlot"] != undefined
        ? _c(
            "div",
            { ref: "icon", staticClass: "popover-container__container" },
            [_vm._t("btnSlot")],
            2
          )
        : _c("i", {
            ref: "icon",
            class: [
              "icon",
              "popover-container__icon",
              _vm.iconClassName,
              _vm.popoverVisible ? "is-active" : ""
            ],
            on: { click: _vm.onIconClick }
          }),
      _c("Popover", {
        attrs: {
          trackedRefName: "icon",
          visible: _vm.popoverVisible,
          placement: _vm.placement,
          zIndex: _vm.zIndex,
          offset: [0, 22],
          disablePortal: _vm.disablePortal,
          hasCloseBtn: _vm.hasCloseBtn,
          maxWidth: _vm.maxWidth,
          hasDivider: _vm.hasDivider,
          state: _vm.state,
          slim: true,
          title: _vm.title,
          positionStrategy: _vm.popoverStrategy
        },
        on: { close: _vm.onClosePopover },
        scopedSlots: _vm._u(
          [
            !_vm.title
              ? {
                  key: "popoverTitle",
                  fn: function() {
                    return [_vm._t("popoverContainerTitle")]
                  },
                  proxy: true
                }
              : null,
            {
              key: "popoverBody",
              fn: function() {
                return [_vm._t("popoverContainerBody")]
              },
              proxy: true
            },
            {
              key: "popoverFooter",
              fn: function() {
                return [_vm._t("popoverContainerFooter")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }